import { FormattedMessage } from 'react-intl';

import { OfferingId } from '@arrived/models';
import { MAX_STALE_TIME, useOfferingQuery } from '@arrived/queries';

export interface FirstDividendDateProps {
  offeringId: OfferingId;
}

export const FirstDividendDate = ({ offeringId }: FirstDividendDateProps) => {
  const offeringState = useOfferingQuery(offeringId, { staleTime: MAX_STALE_TIME });

  switch (offeringState.status) {
    case 'loading':
      return <FormattedMessage id="loading" defaultMessage="Loading..." />;
    case 'error':
      return <>-</>;
    case 'success': {
      const firstDividendDate = offeringState.data.projectedFirstDividendDate;

      if (firstDividendDate != null) {
        return <>{firstDividendDate}</>;
      } else {
        return <>-</>;
      }
    }
  }
};
